import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { ResponseApi } from '../BaseApi';

const documentPanelSlice = createSlice({
    name: 'documentPanel',
    initialState: {
        getAllEmployeeDoc: [],
        getAllSupplierDoc: [],
        getAllContractorDoc: [],
        downloadDocumentById: {},
        deleteDocumentById: {},
        deleteAllDocument: {},
        getAllDepartments: [],
        createEmployeeDoc: {},
        createSupplierDoc: {},
        createContractorDoc: {},
        uploadDocImg: {},
        getAllContractorVehicleDoc: [],
        getAllSupplierVehicleDoc: [],
        deleteAllVehicleDocument: {},
        createSupplierVehicleDoc: {},
        createContractorVehicleDoc: {},
    },
    reducers: {},
    extraReducers: {
        'documentPanel/getAllEmployeeDoc/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllEmployeeDoc = data?.data;
            } else if (status >= 400 && status < 500) {
                toast('Fail to fetch data');
            }
        },
        'documentPanel/getAllSupplierDoc/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllSupplierDoc = data?.data;
            } else if (status >= 400 && status < 500) {
                toast('Fail to fetch data');
            }
        },
        'documentPanel/getAllContractorDoc/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                // toast(data.message)
                state.getAllContractorDoc = data?.data;
            } else if (status >= 400 && status < 500) {
                toast('Fail to fetch data');
            }
        },
        'documentPanel/deleteDocumentById/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteDocumentById = data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/deleteAllDocument/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteAllDocument = data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/getAllDepartments/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllDepartments = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/createEmployeeDoc/fulfilled': (state, action) => {
            state.createEmployeeDoc = ResponseApi(action.payload);
        },
        'documentPanel/createSupplierDoc/fulfilled': (state, action) => {
            state.createSupplierDoc = ResponseApi(action.payload);
        },
        'documentPanel/createContractorDoc/fulfilled': (state, action) => {
            state.createContractorDoc = ResponseApi(action.payload);
        },
        'documentPanel/uploadDocImg/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.uploadDocImg = data;
            } else if (status >= 400 && status < 500) {
            }
        },
        // vehicle  doc
        'documentPanel/getAllContractorVehicleDoc/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllContractorVehicleDoc = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/getAllSupplierVehicleDoc/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllSupplierVehicleDoc = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/deleteAllVehicleDocument/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteAllVehicleDocument = data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/createSupplierVehicleDoc/fulfilled': (state, action) => {
            state.createSupplierVehicleDoc = ResponseApi(action.payload);
        },
        'documentPanel/createContractorVehicleDoc/fulfilled': (state, action) => {
            state.createContractorVehicleDoc = ResponseApi(action.payload);
        },
    },
});

export const {} = documentPanelSlice.actions;

export default documentPanelSlice.reducer;
